module.exports = __webpack_public_path__ + "img/google-robot.4c9acf28.png";